<template>
  <div class="vx-row" v-if="render">
    <!-- Header -->
    <div class="vx-col w-full">
      <!-- <p class="center">Hire villa icon</p>
      <h1 class="center">
        Guest Feedback
      </h1> -->
      <p class="center m-5">
        It was a pleasure for us to host you during your holiday.
      </p>
      <p class="center m-5">
        At Hirevilla, we strive to provide you the absolute best service and your feedback helps us continuously learn and enhance your experience.
      </p>
      <p class="center m-5">
        Please rate us from 10 to 1 with 10 being Excellent and 1 being Poor
      </p>
    </div>
    <div class="vx-col w-2/12"></div>
    <div class="vx-col w-8/12">
    <!-- Property Search -->
      <div class="w-full">
        <v-select
          label="text"
          placeholder="Select Property"
          :options="propertiesOptions"
          @input="propertySelected"
          v-model="property"
          :clearable="false"
        ></v-select>
      <!-- Ratings -->
        <rating
          class ="w-full m-5"
          v-for="(question,index) in questions"
          :key="index"
          :title="question.title"
          :addNotApplicable="question.addNotApplicable"
          :ratingMin="1"
          :ratingMax="5"
          @message="updateMessage(index, $event)"
          @rating="updateRating(index, $event)">
        </rating>

        <!-- Name -->
        <vs-input class="w-full mt-4" label="Name" v-model="name"/>

        <!--<v-select
          class="w-full mt-4"
          :options="options"
          v-model="selectValue"
          :clearable="false">
        </v-select>-->
        <vs-input class="w-full mt-4" label="Mobile Number" v-model="mobile_number"/>
        <vs-input class="w-full mt-4" label="Email" v-model="email"/>
        <div class="vx-col w-full mt-4">
          <label style="font-size: small">Check In Date</label>
          <flat-pickr
            v-model="check_in_date"
            placeholder="Choose date"
            class="w-full"
          />
        </div>
        <div class="vx-col w-full mt-4">
          <label style="font-size: small">Check Out Date</label>
          <flat-pickr
            v-model="check_out_date"
            placeholder="Choose date"
            class="w-full"
          />
        </div>

        <!-- Experience Summary -->
        <vs-input class="w-full mt-4" label="Experience Summary" v-model="experience_summary"/>

        <!-- Memorable Employee -->
        <vs-input class="w-full mt-4" label="Memorable Employee" v-model="memorable_employee"/>

        <v-select
          label="text"
          placeholder="Would you consider staying with us again?"
          :options="considerStayOptions"
          v-model="selected_consider_stay"
          :clearable="false"
          class="w-full mt-4 mb-4"
        ></v-select>

        <!-- Additional Feedback -->
        <!-- <vs-collapse
            class="full mt-4 mb-4"
            accordion
            type="border"
            icon-pack="feather"
            icon-arrow="icon-arrow-down"
            @change="collapeToggled = !collapeToggled"
          >
          <vs-collapse-item
          >
            <div slot="header">
              Additional Feedback
            </div>
            <vs-input class="w-full mt-4" label="Did any particular employee make your stay memorable?" v-model="additional_feedback.employee_name"/>
            <vs-textarea
              class="w-full mt-4 bg-white"
              label="Additional Feedback"
              v-model="additional_feedback.additional_feedback"/>
          </vs-collapse-item>
        </vs-collapse> -->

        <vue-recaptcha
        ref="recaptcha"
        :sitekey="captchaSiteKey"
        @verify="onRecaptchaVerified"
        @expired = "onRecaptchaExpired"
        ></vue-recaptcha>
    </div>
    </div>
    <div class="vx-coll w-full center">
      <vs-button class="m-5" @click="sumbitGuestFeedback">Submit</vs-button>
    </div>
  </div>
</template>

<script>

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'vue-simple-suggest/dist/styles.css'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { showErrors, serverError, notification_time } from '@/utils/errorsUtils'
import PropertyApi from '../../../api/property_management/propertyApi.js'
import Rating from './common/Rating.vue'
import vSelect from 'vue-select'
import GuestFeedBackApi from '../../../api/forms/guestFeedbackFormSubmission.js'
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  components: {
    Rating,
    vSelect,
    'flat-pickr': flatPickr,
    VueRecaptcha,
  },
  watch: {
    collapeToggled (val) {
      if (!val) {
        this.additional_feedback = {
          employee_name: '',
          additional_feedback: ''
        }
      }
    },
    propertyAutoCompleteLoading (val) {
      if (val) {
        this.$vs.loading()
      } else {
        this.$vs.loading.close()
      }
    }
  },
  data () {
    return {
      captchaSiteKey: process.env.VUE_APP_CAPTCHA_SITE_KEY,
      render: false,
      check_in_date: null,
      check_out_date: null,
      questions: [
        {
          title: 'Check-in Experience *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Cleanliness *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Accuracy *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Communication *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Location *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Value for Money *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Overall Experience *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        // {
        //   title: 'Memorable Employee *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // },
        // {
        //   title: 'Security *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // },
        // {
        //   title: 'Housekeeping Efficiency *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // },
        // {
        //   title: 'Housekeeping Friendliness *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // },
        // {
        //   title: 'Internet Speed *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // },
        // {
        //   title: 'Overall Experience *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // }
      ],
      name: '',
      experience_summary: '',
      memorable_employee: '',
      selectValue: {
        id: 1,
        label: 'Mobile Number'
      },
      options: [
        {
          id: 1,
          label: 'Mobile Number'
        },
        {
          id:2,
          label: 'Email'
        }
      ],
      mobile_number: '',
      email: '',
      additional_feedback: {
        employee_name: '',
        additional_feedback: ''
      },
      collapeToggled: false,


      // property search
      property: null,
      propertyAutoCompleteLoading: false,
      selected_property_id: '',
      selected_consider_stay: '',
      propertiesOptions: [],
      considerStayOptions: ["Yes", "No"],
      captchaToken: null
    };
  },
  methods: {
    onRecaptchaVerified(response) {
      // console.log('Recaptcha verified:', response);
      this.captchaToken = response
      // You can do something with the response, e.g., enable the submit button.
    },
    onRecaptchaExpired() {
      // console.log('Recaptcha expired');
      this.captchaToken = null
      // You may want to handle the expiration, e.g., disable the submit button.
    },
    updateMessage (index, value) {
      this.questions[index].message = value
    },
    updateRating (index, value) {
      this.questions[index].rating = value
    },
    fetchGuestFeedbackDetails() {
      if (this.$route.query.token) {
        this.render = false
        GuestFeedBackApi.getGuestFeedbackDetails(this.$route.query.token)
          .then(response => {
            if (response.data.isSuccess) {
              this.render = true
              const feedbackData = response.data.body;
              console.log('feedbackData :>> ', feedbackData);
              // Update form fields with fetched data
              this.name = feedbackData[0].customer_details.name || '';
              this.email = feedbackData[0].customer_details.email || '';
              this.mobile_number = feedbackData[0].customer_details.mobile || '';
              // this.experience_summary = feedbackData.experience_summary || '';
              // this.memorable_employee = feedbackData.memorable_employee || '';
              // this.selected_consider_stay = feedbackData.consider_stay || '';
              this.check_in_date = feedbackData[0].booking_details.arrival_date || null;
              this.check_out_date = feedbackData[0].booking_details.departure_date || null;
              this.selected_property_id = feedbackData[0].booking_details.property_id || '';
              this.property = {
                id: feedbackData[0].booking_details.property_id,
                _id: feedbackData[0].booking_details.property_id,
                text: feedbackData[0].booking_details.property.name || ''
              };
              
              // Update questions if they exist in the response
              // if (feedbackData.questions && feedbackData.questions.length > 0) {
              //   this.questions = feedbackData.questions.map(q => ({
              //     title: q.title,
              //     message: q.message || '',
              //     rating: q.rating || 0,
              //     addNotApplicable: q.addNotApplicable || false
              //   }));
              // }
            } else {
              showErrors(this, response.data.errors);
              // this.$router.push('/pages/error-404');
            }
          })
          .catch(error => {
            console.log(error);
            serverError(this);
            // this.$router.push('/pages/error-404');
          });
      }
    },
    resetForm () {
      this.render = false
      this.questions = [
      {
          title: 'Check-in Experience *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Cleanliness *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Accuracy *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Communication *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Location *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Value for Money *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        {
          title: 'Overall Experience *',
          message: '',
          rating: 0,
          addNotApplicable: false
        },
        // {
        //   title: 'Security *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // },
        // {
        //   title: 'Housekeeping Efficiency *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // },
        // {
        //   title: 'Housekeeping Friendliness *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // },
        // {
        //   title: 'Internet Speed *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // },
        // {
        //   title: 'Overall Experience *',
        //   message: '',
        //   rating: 0,
        //   addNotApplicable: false
        // }
      ]
      this.name = ''
      this.experience_summary= '',
      this.memorable_employee= '',
      this.selectValue = {
        id : 1,
        label : 'Mobile Number'
      }
      this.options = [
        {
          id: 1,
          label: 'Mobile Number'
        },
        {
          id:2,
          label: 'Email'
        }
      ]
      this.mobile_number = ''
      this.email = ''
      this.additional_feedback = {
        employee_name: '',
        additional_feedback: ''
      }
      this.collapeToggled = false


      // property search
      this.property = null
      this.selected_property_id = ''
      this.selected_consider_stay= '',
      setTimeout(() => {
        this.render = true
        this.propertyAutoCompleteLoading = false
      }, 1)
    },
    propertySelected (payload) {
      this.selected_property_id = payload._id
    },

    propertySelected (payload) {
      this.selected_property_id = payload._id
    },

    // considerStaySelected (payload) {
    //   console.log('payload :>> ', payload);
    //   this.selected_consider_stay = payload._id
    // },

    sumbitGuestFeedback () {
      if (!this.captchaToken) {
        this.warn("Complete Captcha");
        return;
      }
      if (this.selected_property_id == '') {
        this.warn('Please select a property')
        return
      }
      if (this.mobile_number == '' && this.email == '') {
        this.warn('Please enter email or mobile number')
        return
      }
      if (this.name == '') {
        this.warn('Please enter a name')
        return
      }
      if (this.check_in_date == null) {
        this.warn('Please enter a check in date')
        return
      }
      if (this.check_out_date == null) {
        this.warn('Please enter a check out date')
        return
      }
      const formObj = {
        property_id: this.selected_property_id,
        mobile_number: this.mobile_number,
        email: this.email,
        employee_name: this.additional_feedback.employee_name,
        additional_feedback: this.additional_feedback.additional_feedback,
        name: this.name,
        experience_summary: this.experience_summary,
        memorable_employee: this.memorable_employee,
        consider_stay: this.selected_consider_stay,
        check_in_date: this.check_in_date,
        check_out_date: this.check_out_date,
        questions: this.questions,
        captchaToken: this.captchaToken,
        token: this.$route.query.token,
      }
      console.log('formObj :>> ', formObj);
      GuestFeedBackApi.submitForm(formObj)
        .then(response => {
          // if (response.data.data.createGuestFeedbackForm.isSuccess) {
          if (response.data.isSuccess) {
            this.showSuccess()
            this.captchaToken = null
            this.$refs.recaptcha.reset();
            this.resetForm()
            this.$router.push('/');
          } else {
            // showErrors(this, response.data.data.createGuestFeedbackForm.errors)
            showErrors(this, response.data.errors)
            this.captchaToken = null
            this.$refs.recaptcha.reset();
          }
        })
        .catch(error => {
          console.log(error)
          this.propertyAutoCompleteLoading = false
          this.captchaToken = null
          this.$refs.recaptcha.reset();
          serverError(this)
        })
    },
    warn (msg) {
      this.$vs.notify({
        title: '',
        text: msg,
        color: 'warning',
        time: notification_time,
        position:'top-right'
      })
    },
    clearPropertySearch () {
      this.property = ''
      this.selected_property_id = ''
    },
    getPropertiesList () {
      this.propertyAutoCompleteLoading = true
      this.render = false
      PropertyApi.getForAutoComplete({})
        .then(response => {
          if (response.data.data.getAllProperties.isSuccess) {
            this.propertiesOptions = this.formatSearchResults(response.data.data.getAllProperties.body)
          } else {
            showErrors(this, response.data.data.getAllProperties.errors)
          }
        }).catch(error => {
          console.log(error)
          serverError(this)
        }).finally(() => {
          this.propertyAutoCompleteLoading = false
          this.render = true
        })
    },
    onPropertySuggestSelect (suggest) {
      // console.log('suggest in property', suggest)
      if (suggest != null) {
        this.property = suggest.text
        this.selected_property_id = suggest._id
      }
    },
    formatSearchResults (results) {
      this.searchResults = results
      const formatted_results = []
      results.forEach(result => {
        formatted_results.push({
          id: result._id,
          _id: result._id,
          text: result.name
        })
      })
      return formatted_results
    },
    showSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Success',
        text: 'The form has been submitted',
        time: notification_time,
        position:'top-right'
      })
    }
  },
  created() {
  // if (!this.$route.query.token) {
  //   this.$router.push('/pages/error-404');
  //   return;
  // }

  (async () => {
    await this.getPropertiesList();
    await this.fetchGuestFeedbackDetails();
  })();
}
}
</script>

<style>
  .center{
    flex: center;
    text-align: center;
  }
</style>
